export const comparePasswords = ({ getFieldValue }: { getFieldValue: (value: string) => string }) => ({
  validator(_: string, value: string) {
    if (!value || getFieldValue('newPassword') === value) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Пароли не совпадают'));
  }
});
